export default function Go_Nested_if_Statement () {
  return (
    <div>
      <h1>Go_Nested_if_Statement </h1>
      <p>Nested if Statement</p>
    </div>
  );
}